import type { ReactNode } from 'react';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      // TODO spike if we can connect this with our backend CacheControl
      refetchOnWindowFocus: false,
      // Don't retry failed queries
      retry: false,
    },
  },
});

/**
 * Default cache provider for REST queries (based on @tanstack/react-query)
 */
export function RestProvider({ children }: { children: ReactNode }) {
  return <QueryClientProvider client={queryClient}>{children}</QueryClientProvider>;
}
